import axios from 'axios';

import { webpack } from '@dr.pogodin/react-utils';

import type { ListUsersQueryT, ListUsersResT } from 'server/controllers';

import type * as SSNS from 'server/services/user';

import { P_API_USERS, type UserListT } from 'utils';

export { type ListUsersQueryT };

const ss = webpack.requireWeak<typeof SSNS>(
  'server/services/user',
  import.meta.dirname,
);

export async function listUsers(
  options: ListUsersQueryT,
): Promise<UserListT> {
  if (ss) return ss.listUsers(options);

  const res = await axios<ListUsersResT>(
    P_API_USERS,
    { params: options satisfies ListUsersQueryT },
  );

  return res.data;
}
